import { createStore } from 'vuex';
import isMobile from '@/shared/store/isMobile';
import isTablet from '@/shared/store/isTablet';
import mobileNav from '@/shared/store/mobileNav';
// eslint-disable-next-line import/no-cycle
import esiaLogin from '@/features/AuthByEsia/store/esiaLogin';
// eslint-disable-next-line import/no-cycle
import authByPhone from '@/features/AuthByPhone/store/authByPhone';
import historyFeatures from '@/features/HistoryFeatures/store/historyFeatures';
import payment from '@/features/Payment/store/payment';
import calculator from '@/features/Calculator/store/calculator';
import loanApp from '@/features/LoanApp/store/loanApp';
import infoStatus from '@/entities/components/InfoStatus/store/infoStatus';
import webPush from '@/features/WebPush/store/web-push';
import approved from '@/features/Approved/store/approved';
import { clearCookie, getCookie } from '@/shared/lib/helpers/cookies';
import steps from '@/entities/components/Steps/store/steps';
import requestCall from '@/widgets/Header/store/requestCall';
import fetchContractDetails from '@/features/ContractDetails/store/fetchContractDetails';
import fetchDocumentsForActiveContract
from '@/features/DocumentsForActiveContract/store/fetchDocumentsForActiveContract';
import archieve from '@/features/Archieve/store/archieve';
import { postApi } from '@/shared/api';
import passportDownload from '@/entities/components/PassportDownload/store/passportDownload';

const {	VUE_APP_WSADDRESS } = process.env;

export default createStore({
	state: {
		token: getCookie('token'),
		centrifugeToken: getCookie('centrifugeToken'),
		centrifugeStatus: {
			loanStatus: null,
			payoutStatus: {
				status: null,
				errorMessage: null,
			},
		},
		WSAddress: VUE_APP_WSADDRESS,
		user: null,
		showContactMethods: false,
		globalPreloader: false,
		availablePromos: [],
		contract: null,
		loan: null,
		payout: {
			status: null,
		},
		hasActiveContract: false,
		hasActiveLoan: false,
		paymentMethod: 'sbp',
		showPaymentMethods: false,
		buttonPreloader: false,
		initError: null,
		pwaEvent: null,
	},
	mutations: {
		SET_PWA_EVENT(state, val) {
			state.pwaEvent = val;
		},
		SET_INIT_ERROR(state, val) {
			state.initError = val;
		},
		SET_CONTACT_METHODS(state, val) {
			state.showContactMethods = val;
		},
		SET_GLOBAL_PRELOADER(state, val) {
			state.globalPreloader = val;
		},
		SET_BUTTON_PRELOADER(state, val) {
			state.buttonPreloader = val;
		},
		SET_TOKEN(state, val) {
			state.token = val;
		},
		SET_CENTRIFUGE_TOKEN(state, val) {
			state.centrifugeToken = val;
		},
		SET_USER(state, val) {
			state.user = val;
		},
		SET_PROMOS(state, val) {
			state.availablePromos = val;
		},
		SET_LOAN(state, val) {
			state.loan = val;
		},
		SET_CENTRIFUGE_STATUS(state, val) {
			state.centrifugeStatus = val;
		},
		SET_PAYOUT_STATUS(state, val) {
			state.payoutStatus = val;
		},
		SET_ACTIVE_CONTRACT(state, val) {
			state.contract = val;
		},
		HAS_ACTIVE_CONTRACT(state, val) {
			state.hasActiveContract = val;
		},
		HAS_ACTIVE_LOAN(state, val) {
			state.hasActiveLoan = val;
		},
		SET_PAYMENT_METHOD(state, val) {
			state.paymentMethod = val;
		},
		SHOW_PAYMENT_METHODS(state, val) {
			state.showPaymentMethods = val;
		},
		LOGOUT(state, location = '/login') {
			console.log('LOGOUT');
			clearCookie('token');
			clearCookie('centrifugeToken');
			state.token = null;
			state.centrifugeToken = null;
			window.location.href = location;
		},
	},
	actions: {
		async logOut({ commit }) {
			try {
				const response = await postApi('/k5/v1/auth/logout');
				console.log('logOut response', response);
				if (response.data.status === true && response.data?.data?.redirect) {
					commit('LOGOUT', response.data.data.redirect);
				}
			} catch (e) {
				console.log('logout Error:', e);
			}
		},
		// eslint-disable-next-line no-empty-pattern
		base64toBlob({}, { base64, contentType = '', sliceSize = 512 }) {
			const byteCharacters = atob(base64);
			const byteArrays = [];

			for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				const slice = byteCharacters.slice(offset, offset + sliceSize);

				const byteNumbers = new Array(slice.length);
				// eslint-disable-next-line no-plusplus
				for (let i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				const byteArray = new Uint8Array(byteNumbers);
				byteArrays.push(byteArray);
			}

			const blob = new Blob(byteArrays, { type: contentType });
			return blob;
		},

		// eslint-disable-next-line no-empty-pattern
		blobToLink({}, blob) {
			return window.URL.createObjectURL(blob);
		},

		async base64toBlobLink({ dispatch }, { base64, contentType = '', sliceSize = 512 }) {
			let linkBlob = null;
			await dispatch('base64toBlob', { base64, contentType, sliceSize }).then(
				async (blob) => {
					await dispatch('blobToLink', blob).then(
						(link) => {
							linkBlob = link;
						},
					);
				},
			);
			return linkBlob;
		},
	},
	getters: {
		hasAsp(state) {
			return Boolean(state.user.ahs !== '');
		},
	},
	modules: {
		isMobile,
		isTablet,
		mobileNav,
		esiaLogin,
		authByPhone,
		historyFeatures,
		payment,
		calculator,
		loanApp,
		infoStatus,
		approved,
		steps,
		requestCall,
		fetchDocumentsForActiveContract,
		archieve,
		fetchContractDetails,
		webPush,
		passportDownload,
	},
});
